import Vue from 'vue'
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

// 导入App 语言包

const navLang = navigator.language;
// // console.log(navLang, 'navLang')

const localLang = (navLang === 'zh-CN' || navLang === 'en-US') ? navLang : false;
// console.log(localLang,'test')
console.log(window.localStorage.getItem('language'),'sssss')
const lang = window.localStorage.getItem('language') ? window.localStorage.getItem('language') : localLang;
console.log(window.localStorage.getItem('language'),'sssss')
console.log(lang)
const i18n = new VueI18n({
    locale: lang,    // 语言标识
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
        'zh-CN': require('./zh-CN.js').default,   // 中文语言包
        'en-US': require('./en-US.js').default // 英文语言包
                // 英文语言包
    }
});

export {i18n}



// WEBPACK FOOTER //
// ./src/language/index.js